import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import s from './PopupOverview.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import popupBehaviour from './popupBehaviour';

class PopupOverview extends React.Component {
  
  render() {
    const { deviceType } = this.props;
    const PopupOverviewClose = 
      deviceType === 'superior' 
        ? classNames(s.PopupOverview_close, s.close_spirotech) 
        : classNames(s.PopupOverview_close);
    return (
      <div className={s.PopupOverview}>
        <div className={s.PopupOverview_overlay} onClick={this.props.onClose}/>
        <div className={s.PopupOverview_content}>
          <button
            type="button"
            className={PopupOverviewClose}
            onClick={this.props.onClose}
          >
            <Icon iconName={"odrzuc"} size={20}/>
          </button>
          <div className={classNames(s.PopupOverview_box)}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
PopupOverview.propTypes = {
  onClose: PropTypes.func.isRequired,
  clean: PropTypes.bool,
  deviceType: PropTypes.string,
  children: PropTypes.node,
};

PopupOverview.defaultProps = {
  deviceType: 'softener',
}

export default popupBehaviour(withStyles(s)(PopupOverview));



// WEBPACK FOOTER //
// ./src/components/Popup/PopupOverview.js